import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";

export const GAME = "game";

export const getCurrentHomeworkSetting = createAsyncThunk(
    `${GAME}/getCurrentHomeworkSetting`,
    async () => {
        const response = await client.get('/hw/mental/byStudent')
        return response.data
    }
)

export const getSettingByHWId = createAsyncThunk(
    `${GAME}/getSettingByHWId`,
    async (hwId) => {
        const response = await client.get(`/hw/step/getByHWId/${hwId}`)
        return response.data
    }
)

export const getTask = createAsyncThunk(
    `${GAME}/getTask`,
    async (body) => {
        const response = await client.post(`/task`, body)
        return response.data
    }
)

export const sendAnswer = createAsyncThunk(
    `${GAME}/sendAnswer`,
    async (body) => {
        const response = await client.post(`/task/saveAnswer`, body)
        return response.data
    }
)